import { render, staticRenderFns } from "./Szerkezetepites.vue?vue&type=template&id=3949d10c&"
import script from "./Szerkezetepites.vue?vue&type=script&lang=js&"
export * from "./Szerkezetepites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports